const vimeoPlayerUrl = (videoId: string) =>
  `//player.vimeo.com/video/${videoId}?autoplay=1&title=1&byline=1&portrait=0&fullscreen=1`;

export default vimeoPlayerUrl;
